import { render, staticRenderFns } from "./jfdetail.vue?vue&type=template&id=e6003efc&scoped=true&"
import script from "./jfdetail.vue?vue&type=script&lang=js&"
export * from "./jfdetail.vue?vue&type=script&lang=js&"
import style0 from "./jfdetail.vue?vue&type=style&index=0&id=e6003efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6003efc",
  null
  
)

export default component.exports